module.exports = __webpack_public_path__ + "static/media/INFORMACJA O AGENCIE - fuzja Generali-Concordia.04447d7b.pdf";